<atn-ds-table [config]="zonesTableConfigSg()" />
<atn-admin-zone-modal />

@if (zonesEc.plugins.editingPlugin.feature.selectors.hasDeletions.asSignal()) {
  @let deletionError =
    zonesEc.plugins.editingPlugin.feature.selectors.submissionError.asSignal();
  <atn-ds-confirmation-overlay
    title="Delete Zone"
    [description]="
      'Are you sure you want to delete <b>' +
      zoneNameForDeleteSg() +
      '</b>? This action cannot be undone. ' +
      '<br> Please type <b>' +
      zoneNameForDeleteSg() +
      '</b> in the field below to confirm this action.'
    "
    [error]="deletionError"
    [validation]="zoneNameForDeleteSg()"
    (cancel)="cancelDeletionClickHandler()"
    (confirm)="confirmDeletionClickHandler()"
    confirmButtonText="Delete"
  />
}
